var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"custom-loader",class:{ 'is-centered': _vm.centered }},[_c('span',{class:{ 'has-logo': _vm.logo },style:({ fontSize: `${_vm.size}em` })})])
}
var staticRenderFns = []

export { render, staticRenderFns }